import vrole from "./vrole"
import vAuth from "./vAuth"
export const installDirectives = (app) => {
  console.log("注册自定义指令")
  vrole(app)
  vAuth(app)
}
